import React from 'react';

export default class AsicTypeTable extends React.Component {

    state = {
        
    }

    editAsicType(id){
        this.props.editFunction(id)
    }

    deleteAsicType(id){
        this.props.deleteFunction(id)
    }

    changeState(state, e){
        this.props.changeState(state, e.target.value);
    }

    render() {
        return (
            <div className="component user-table">
                <div className="panel pl-0 pr-0 pt-0 pb-0">
                    <table className="bordered">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Vendor</th>
                                <th>Model</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(this.props.asictypes) &&
                                this.props.asictypes.map((asictype, i)=>{
                                    return <tr key={i}>
                                                <td>{asictype.id}</td>
                                                <td>{(asictype.asicVendor) ? asictype.asicVendor.name : ''}</td>
                                                <td>{asictype.model}</td>                                                
                                                <td className="actions">
                                                    {(this.props.user.userType.permissions.find((el) => el.id === 24)) &&
                                                    <div className="dropdown">
                                                        <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">                                                            
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <button className="dropdown-item"
                                                                onClick={this.editAsicType.bind(this, i)}
                                                            >Edit</button>
                                                            <button className="dropdown-item" href="#"
                                                                onClick={this.deleteAsicType.bind(this, i)}
                                                            >Delete</button>
                                                        </div>
                                                    </div>
                                                    }
                                                </td>
                                            </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}